module.exports = __webpack_public_path__ + "img/aiopen-partnerslogo-transparent.5761dbd9.png";